/* @flow */

import { Tr, Td } from 'components/UIKit/Table';

type ErrorSummaryRowProps = {
  children: any
}

export default function ErrorSummaryRow({
  children,
}: ErrorSummaryRowProps): React.Element {
  return (
    <Tr>
      <Td>{children.errorType}</Td>
      <Td style={{ textTransform: 'capitalize' }}>{ children.severity}</Td>
      <Td>{ children.description }</Td>
      <Td style={{ textAlign: 'right' }}>{ children.count }</Td>
    </Tr>
  );
}
